import React, { useRef, useState } from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import { MoreIcon } from '../../../../components/icons';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';

/** Task Report-specific row action menu; eligibility is advisory to server authorization. */
export default function TaskReportRowActions({ noTask, taskName, checkEligibility, downloadWorkbook, disabled = false }) {
   const [anchor, setAnchor] = useState(null);
   const [checking, setChecking] = useState(false);
   const [eligibility, setEligibility] = useState(null);
   const [downloading, setDownloading] = useState(false);
   const [error, setError] = useState('');
   const inProgress = useRef(false);
   const available = typeof checkEligibility === 'function' && typeof downloadWorkbook === 'function';

   const close = () => { if (!inProgress.current) setAnchor(null); };
   const open = async (event) => {
      if (disabled || !available || inProgress.current) return;
      setAnchor(event.currentTarget);
      setError('');
      setChecking(true);
      setEligibility(null);
      try {
         const result = await checkEligibility(noTask);
         setEligibility(result);
      } catch (err) {
         setError(err?.message || 'Unable to check download availability.');
      } finally {
         setChecking(false);
      }
   };
   const startDownload = async (layout) => {
      if (inProgress.current || checking || !eligibility?.structuredAvailable ||
          (layout === 'Flat' && !eligibility.flatEligible)) return;
      inProgress.current = true;
      setDownloading(true);
      setError('');
      try {
         await downloadWorkbook({ noTask, layout });
         setAnchor(null);
      } catch (err) {
         setError(err?.message || 'Excel download failed. Please try again.');
      } finally {
         inProgress.current = false;
         setDownloading(false);
      }
   };
   const flatReason = eligibility?.flatReason || 'Flat Excel is unavailable for this form. Choose Structured Excel.';
   const busy = checking || downloading;

   return (
      <>
         <div className='ButtonMenu'>
            <ButtonBase className='circle' aria-label={`Actions for ${taskName || `Task ${noTask}`}`} disabled={disabled || !available || busy} onClick={open}>
               {busy ? <CircularProgress size={15} /> : <MoreIcon style={{ color: '#1F2E36' }} size={10} />}
            </ButtonBase>
         </div>
         <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close} keepMounted>
            {checking && <MenuItem disabled>Checking available layouts…</MenuItem>}
            {!checking && eligibility && (
               <>
                  <Tooltip title={!eligibility.flatEligible ? flatReason : ''} placement='left'>
                     <span><MenuItem disabled={downloading || !eligibility.flatEligible || !eligibility.structuredAvailable} onClick={() => startDownload('Flat')}>
                        Download Flat Excel{!eligibility.flatEligible ? ' — unavailable' : ''}
                     </MenuItem></span>
                  </Tooltip>
                  <MenuItem disabled={downloading || !eligibility.structuredAvailable} onClick={() => startDownload('Structured')}>
                     Download Structured Excel
                  </MenuItem>
               </>
            )}
            {!checking && error && <MenuItem disabled>{error}</MenuItem>}
         </Menu>
      </>
   );
}
